<template>
  <div class="index-box">
    <div style="margin-bottom: 0.5rem; ">
      <p class="text-title">客户营收管理</p>
    </div>
    <a-row :gutter="8">
      <a-col :span="12">
        <a-row :gutter="8">
          <a-col :span="8">
            <div class="rightContainer">
              <div class="rightTotal">
                <span class="total-label">月度业绩目标完成率</span>
                <span class="total-number center-rate">{{ keyData.targetCompletionRate }}</span>
              </div>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="rightContainer">
              <div class="rightTotal">
                <span class="total-label">月度业绩实际完成值（万元）</span>
                <span class="total-number center-rate">{{ keyData.completionValueTotal }}</span>
              </div>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="rightContainer">
              <div class="rightTotal">
                <span class="total-label">月度业绩目标值（万元）</span>
                <span class="total-number center-rate">{{ keyData.targetValueTotal }}</span>
              </div>
            </div>
          </a-col>
        </a-row>
        <!-- 每月绩效完成情况 -->
        <MonthlyTargetCompletion appId="cos_fbu" :employeeNo="props.employeeNo"/>
      </a-col>
      <a-col :span="12">
        <!-- 新激活客户数 -->
        <NewActivatedCustomerCount appId="cos_fbu" :employeeNo="props.employeeNo"/>
        <!-- 新激活客户月销售额 -->
        <NewActivatedCustomerMonthlyRevenue appId="cos_fbu" :employeeNo="props.employeeNo"/>
      </a-col>
    </a-row>
  </div>
</template>
<script setup lang="ts">

import { onMounted, PropType, ref, watch } from 'vue'
import MonthlyTargetCompletion from '@/views/gucangSales/dataBoard/componects/MonthlyTargetCompletion.vue'
import NewActivatedCustomerCount from '@/views/gucangSales/dataBoard/componects/NewActivatedCustomerCount.vue'
import NewActivatedCustomerMonthlyRevenue
  from '@/views/gucangSales/dataBoard/componects/NewActivatedCustomerMonthlyRevenue.vue'
import { getCustomerRevenueDataBoard } from '@/api/gucangSales/dataBoard'

const props = defineProps({
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    default: 'cos_fbu'
  },
  /// 数据权限查询类型,【没有工号则dataPermissionQueryType1/2,全部数据/指定工号(工号必填)】
  employeeNo: {
    type: String as PropType<string>
  },
  formState: {
    type: Object as PropType<Object>
  }
})
const keyData = ref<any>({})
onMounted(() => {
  getCustomerRevenueDashData()
})
watch(() => props.formState, (val) => {
  getCustomerRevenueDashData()
})
const getCustomerRevenueDashData = () => {
  getCustomerRevenueDataBoard(props.formState)
    .then((res:any) => {
      // 月度业绩目标值
      keyData.value.targetValueTotal = res.data?.targetValueTotal ?? 0
      // 月度业绩实际完成值
      keyData.value.completionValueTotal = res.data?.completionValueTotal ?? 0
      // 月度业绩目标完成率
      keyData.value.targetCompletionRate = res.data?.targetCompletionRate ?? '0%'
    })
}
</script>
<script lang="ts">
export default {
  name: 'CustomerRevenueManagement'
}
</script>
<style scoped lang="scss">
.index-box {
  background: rgb(249, 249, 255);
  padding: 10px;
}
.text-title {
  font-size: 20px;
  font-weight: 500;
  color: #000;
}
.rightContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 20px 20px 20px;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  height: 140px;
  margin-bottom: 8px;
}
.rightTotal {
  font-size: 20px;
  width: 100%;
  margin-bottom: 20px;
}
.total-label {
  font-size: 14px;
  color: #5B687D;
}

.total-number {
  font-family: Lato,sans-serif;
  display: block;
  font-size: 32px;
  color: #26292E;
  letter-spacing: 1px;
  margin-top: 10px;
  font-weight: 800;
  line-height: 36px;
  text-align: left;
}
.total-number.center-rate {
  text-align: center;
}
</style>
